/**
 * NotFound — a real 404 (the old router silently bounced unknown URLs to
 * the landing page, which reads as broken; contest brief, 2026-07-11).
 */
import { Link } from "react-router-dom";
import { Compass, ArrowRight } from "lucide-react";
import { useSEO } from "@/lib/seo";

export default function NotFound() {
  useSEO({ title: "Page not found", description: "That page doesn't exist.", path: "/404" });

  return (
    <div
      className="min-h-[70vh] flex items-center justify-center px-5 bg-[color:var(--cream)]"
      data-testid="not-found-page"
    >
      <div className="brutal-card bg-white p-8 max-w-md w-full text-center">
        <span className="inline-flex w-14 h-14 rounded-2xl border-[3px] border-[color:var(--ink)] bg-[color:var(--gold)] items-center justify-center mb-4">
          <Compass size={26} aria-hidden />
        </span>
        <h1 className="display text-3xl font-extrabold mb-2">That page isn&rsquo;t here.</h1>
        <p className="text-sm text-[color:var(--ink-soft)] leading-relaxed mb-6">
          The link may be old or mistyped. Everything worth seeing is one tap
          away.
        </p>
        <div className="grid gap-2">
          <Link to="/" className="pill-btn primary justify-center" data-testid="notfound-home">
            Go to the homepage <ArrowRight size={14} aria-hidden />
          </Link>
          <Link to="/demo" className="pill-btn justify-center">Try the live demo</Link>
          <Link to="/contact" className="pill-btn justify-center">Contact us</Link>
        </div>
      </div>
    </div>
  );
}
